// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2Nk19","rootCenter":"LoadMoreObserver_rootCenter__TEeTI","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1nVTv"};